import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import {questionnaireActions} from "_actions";
import * as _ from 'lodash';
import {history} from '_helpers/history'
import {Space, Button, Modal, Radio} from 'antd';
import "./startCeiba.scss";
import {
    ArrowRightOutlined,
    EditOutlined,
    ReloadOutlined
} from "@ant-design/icons";
import Headerbutton from "../component/headerButton";
import variables from "../../../_constants/variables";
import report from '../../../assets/img/report.png';
import SliderV from "../../../components/Slider/SliderV";
import {xcService} from "../../../_services/xcService";

function EndXcelence(props) {

    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [disabled, setDisabled] = useState(true);

    const [data, setData] = useState(null);
    const [assessment, setAssessment] = useState(null);
    const [modalItem, setModalItem] = useState();
    const [answers, setAnswers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [points, setPoints] = useState(0)
    const [touch, setTouch] = useState(false);
    const [valueOb, setValueOb] = useState(null);
    const [responses, setResponses] = useState([]);
    const responsesData = useSelector((state) => state.questionnaireReducer.responsesData);

    var answersData = useSelector((state) => state.questionnaireReducer.answersData);
    var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);
    var assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);


    useEffect(() => {
        if (assestmentsCodeData) {


            setData(assestmentsCodeData);
        }
    }, [assestmentsCodeData]);
    useEffect(() => {
        if (answersData) {
            setAnswers(answersData);
            if (data && data.length) {
                if (answersData.length === data.length) {
                    history.push("/admin/end-xcelence")
                }
            }
        }
    }, [answersData, answersDataError])

    useEffect(()=>{
            if(!assessment) return;
            dispatch(questionnaireActions.getResponses(assessment.assessment_id));
        }, [assessment]
    )

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("XCELENCE"))
        dispatch(questionnaireActions.getAnswers("XCELENCE"))

    }, []);


    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);

    useEffect(() => {
        if (saveAnswer){
            setShowModal(false)

            setPoints(0);
            setValueOb(null);
            dispatch(questionnaireActions.getAssessmentsCode("XCELENCE"));
            dispatch(questionnaireActions.getAnswers("XCELENCE"));
        }
    },[saveAnswer])


/*     const Continue = () => {
        setShowModal(false)
        setQuestion(null)
        dispatch(questionnaireActions.getAssessmentsCode("XCELENCE"))
        dispatch(questionnaireActions.getAnswers("XCELENCE"))
    } */

    const openModal = (item) => {
        getPointRes(item)
        //setPoints(getPointResponse(item))
        if(item.questionType==='SINGLE') {
            setAssessment(responses.find(res => res.assessment_id === item.id))
        }
        setModalItem(item);
        setShowModal(true);


    }

    const updateValue = () => {
        dispatch(questionnaireActions.saveAnswer({
            yesno: valueOb,
            points: valueOb === 0 ? 0 : points,
            assessment_id: modalItem.id
        }))

    }

    const getPoint = (item) => {

        let mAnswer = answers.filter(it => it.assessment_id === item.id);
        if (mAnswer[0]) {
            if (item.questionType === "RATING") {
                return mAnswer[0].points
            }
            if (item.questionType === "RATINGOB") {

                return mAnswer[0].yesno === 1 ? t("yes") + ". " + mAnswer[0].points : t("no")
            }
            if (item.questionType === "SINGLE") {
                return mAnswer[0].response.question
            }
        } else {
            return "";
        }

    }


    const getPointRes = (item) => {

        let mAnswer = answers.filter(it => it.assessment_id === item.id);
        if (mAnswer[0]) {
            if (item.questionType === "RATING") {
                setPoints(mAnswer[0].points)
            }
            if (item.questionType === "RATINGOB") {
                setPoints(mAnswer[0].points)
                setValueOb(mAnswer[0].yesno)
            }
        } else {
            return "";
        }

    }

    const saveAndContinue = () => {
        localStorage.removeItem(variables.LASTXCELENCE);
        localStorage.removeItem(variables.LASTCEIBA);
        history.push("/admin/assessment")
    }


    const onChangeRadio = (e) => {

        setValueOb(e.target.value);

        if (!e.target.value) {
            setDisabled(false);
            setTouch(true)
        }
    }

    const closeModal = () => {

        setShowModal(false)
    }


    const retrieveResponse = async (id,answerId)=> {
        let apiEndpoint = "/v1/response/assessment/"+id;
        const res = await xcService.getToken(apiEndpoint);
        return res.data.data.find(res=>res.id===answerId);
    }

    useEffect(() => {
            if(!(data&&answers.length>0)) return;
            const res = data.filter(item=>item.questionType==="SINGLE")
                .map(item=> {
                    let mAnswer = answers.find(it => it.assessment_id === item.id);
                    return retrieveResponse(item.id,mAnswer.points)
                })
            Promise.all(res).then((reses)=> {
                    setResponses(reses)
                }
            );
        },
        [data,answers]
    )
    return (
        <div className={"backGroundCeiba"}>

            {showModal &&
                <Modal title={t("ceiba.modificar")}
                       centered
                       visible={showModal} 
                       onOk={() => updateValue()}
                       onCancel={() => closeModal()}>

                    <p>{modalItem.question}</p>
                    <>
                        <>
                            {modalItem.questionType === 'RATING' &&
                                <SliderV
                                    value={points}
                                    dots={true}
                                    style={{marginTop: 20}}
                                    onChange={setPoints}
                                    min={1}
                                    max={10}
                                />
                            }
                            {modalItem.questionType === "RATINGOB" &&
                                <>
                                    <Radio.Group onChange={onChangeRadio} value={valueOb}>
                                        <Space direction="vertical">
                                            <Radio value={1}>{t("yes")}</Radio>
                                            <Radio value={0}>{t("no")}</Radio>
                                        </Space>
                                    </Radio.Group>
                                    {valueOb === 1 &&
                                        <>
                                            <div >
                                                <p><strong>{t("xcelence.misat")}</strong></p>
                                                <SliderV
                                                    dots={true}
                                                    style={{marginTop: 20}}
                                                    step={1}
                                                    value={points}
                                                    onChange={setPoints}
                                                    min={1}
                                                    max={10}/>
                                            </div>
                                        </>
                                    }

                                </>
                            }
                            {modalItem.questionType==='SINGLE'&&responsesData?.length>0&&
                                <Radio.Group

                                    onChange={(value)=>setPoints(value.target.value)}
                                    value={points}
                                    options={responsesData
                                        .map(response=>{
                                            return {
                                                label:response.question,
                                                value:response.id
                                            }})}>
                                </Radio.Group>
                            }
                        </>
                    </>
                </Modal>
            }

            <div className={"wrapper-question boxed"}>
                <div className={"insideCeiba boxed"}>
                    <Headerbutton saveAndContinue={saveAndContinue} title={t("xcelence.header")}/>
                </div>
                <div className={"container-question container-question__end no-gamificado"}>
                    <div className={"container-question__auto-margin"}>
                        <div className={"question__header"}>
                            <img className={"question__header-icon"} src={report}/>
                            <h2>{t("xcelence.endtitle")}</h2>
                        </div>
                        <div className={"question__content"}>
                            <div className={"question__content-list"}>
                                {data && data.map((item, index) => (
                                    <div className={"list-item"}>
                                        <div className={"list-item-l"}>
                                            <p>{item.question}</p>
                                        </div>
                                        <div className={"list-item-r"}>
                                            <p>{getPoint(item)}</p>
                                            <div
                                                className={"modifica"}
                                                onClick={() => openModal(item)}
                                            >
                                                {t("ceiba.modificar")}&nbsp;<EditOutlined/>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={"question__content-bottom"}>
                                <div className="left">
                                    <Button
                                        icon={<ReloadOutlined/>}
                                        type={"secondary"}
                                        className="primaryButton"
                                        onClick={() => history.push('/admin/xcelence?restart=true')}
                                    >
                                        {t("reset")}
                                    </Button>
                                </div>
                                <div className="right">
                                    <Button
                                        icon={<ArrowRightOutlined/>}
                                        onClick={() => history.push("/admin/assessment")}
                                        type={"primary"}
                                        className="primaryButton"
                                    >
                                        {t("tek.irahome")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default withTranslation()(EndXcelence);
